{
	"errorPage.404.button": "Voltar à Página inicial",
	"errorPage.404.code": "Erro 404",
	"errorPage.404.description": "A página que você está procurando não existe ou foi movida.",
	"errorPage.404.title": "Página não encontrada...",
	"errorPage.network.description": "Não foi possível carregar a página.\nVerifique a configuração da sua internet e tente novamente.",
	"errorPage.network.title": "Ocorreu um erro…",
	"global.refreshButton": "Atualizar",
	"global.toast.error.message": "Ocorreu um erro. Tente novamente.",
	"global.toast.error.title": "Erro"
}
